import React from 'react';
import DOMPurify from 'dompurify';
import './star.scss';

class SafeHtmlPreview extends React.Component {
    constructor(props) {
        super(props);
        this.containerRef = React.createRef();
    }

    componentDidMount() {
        if (this.containerRef.current) {
            this.containerRef.current.innerHTML = DOMPurify.sanitize(this.props.html || '');
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.html !== this.props.html && this.containerRef.current) {
            this.containerRef.current.innerHTML = DOMPurify.sanitize(this.props.html || '');
        }
    }

    render() {
        return <div className={this.props.className} ref={this.containerRef} />;
    }
}

export default class Star extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tip: '',
        }
    }

    static defaultProps = {
        data: null,
        active: false,
        tipPosition: 'bottom',
        tips: {
            saved: 'SAVED',
            removed: 'REMOVED',
            error: 'ERROR'
        }
    }

    componentWillUnmount() {
        clearTimeout(this.tipTimer);
    }

    render() {
        const tip = this.renderTip(this.state.tip);
        const className = 'pubhub-agenda-star ' + (this.props.active ? 'active' : 'unactive');
        return (
            <div className={className} onClick={this.onClick}>
                <div className='icon-container'>
                    <i className="fas fa-star star" />
                </div>
                {tip}
            </div>
        );
    }

    renderTip(tip) {
        if (!tip || this.busy) return null;

        const className = 'tip '
            + (this.props.active ? 'active' : 'unactive')
            + ' ' + this.props.tipPosition
            + ' ' + this.state.tipType;

        return (
            <SafeHtmlPreview className={className} html={tip} />
        );
    }

    onClick = () => {
        if (this.busy) return;

        if(this.props.onBeforeChange) {
            if(!this.props.onBeforeChange(this.props.data)) {
                return;
            }
        }

        this.busy = true;
        const tip = this.props.active ? this.props.tips.removed : this.props.tips.saved;

        clearTimeout(this.tipTimer);

        this.props.onChange && this.props.onChange(this.props.data, (err) => {
            this.busy = false;
            const ms = err ? 3000 : 2000;
            if (err) {
                this.setState({ tip: this.props.tips.error, tipType: 'error' });
            } else {
                this.setState({ tip, tipType: 'info' });
            }

            this.tipTimer = setTimeout(() => {
                this.setState({ tip: '', tipType: 'info' });
            }, ms);
        });
    }
}